import { Box, Divider, List, Typography } from '@mui/material'
import type { PrizeToImport } from 'types/Prize'
import { PrizeElement } from './prize-element'

export const PrizesSignatures = ({ prizes }: { prizes: PrizeToImport[] }): JSX.Element => {
  return (
    <Box width="100%">
      <Typography variant="h6" component="h3" fontWeight={600}>
        Prize signatures
      </Typography>
      <Typography variant="body2" component="p">
        Copy the signature and paste it in your .xlsx file next to winner’s name
      </Typography>
      <Divider sx={{ my: 1 }} />
      <List sx={{ gap: 1, display: 'flex', flexDirection: 'column' }}>
        {prizes.map(prize => (
          <PrizeElement key={prize.name} prize={prize} />
        ))}
      </List>
    </Box>
  )
}
